export enum CalculationKeynameEnum {
  VehicleOwnership = 'VEHICLE_OWNERSHIP',
  Section84_1 = 'SECTION_84_1',
  Section84_3 = 'SECTION_84_3',
  Rollover = 'ROLLOVER',
  RolloverSimplified = 'ROLLOVER_SIMPLIFIED',
  SalaryContributions = 'SALARY_CONTRIBUTIONS',
  WithholdingTax = 'WITHHOLDING_TAX',
  Schedule8 = 'SCHEDULE_8',
  Schedule10 = 'SCHEDULE_10',
  ScheduleP = 'SCHEDULE_P',
  ScheduleR = 'SCHEDULE_R',
  FSS = 'FSS',
  RRQ = 'RRQ',
  CNT = 'CNT',
  CNESST = 'CNESST',
  IncomeTaxPersonalFederal = 'INCOME_TAX_PERSONAL_FEDERAL',
  IncomeTaxPersonalQuebec = 'INCOME_TAX_PERSONAL_QUEBEC',
  IncomeTaxPersonal = 'INCOME_TAX_PERSONAL',
  T778 = 'T778',
  CorporateTaxQuebec = 'CORPORATE_TAX_QUEBEC',
  CorporateTaxFederal = 'CORPORATE_TAX_FEDERAL',
  CorporateTax = 'CORPORATE_TAX',
  SalaryDividend = 'SALARY_DIVIDEND',
  SalaryDividendSimulation = 'SALARY_DIVIDEND_SIMULATION',
  Vehicle = 'VEHICLE',
  QppPension = 'QPP_PENSION',
  Rrsp = 'RRSP',
  RrspSimulation = 'RRSP_SIMULATION',
  QppPensionForSalaryDividend = 'QPP_PENSION_FOR_SALARY_DIVIDEND',
  RenteRRQ = 'RENTE_RRQ',
  FamilyAllowance = 'FAMILY_ALLOWANCE',
  CCB = 'CCB',
}
